// extracted by mini-css-extract-plugin
export var button = "add-recipe-to-plan-modal-module--button--37a96";
export var form = "add-recipe-to-plan-modal-module--form--51827";
export var grid = "add-recipe-to-plan-modal-module--grid--2b235";
export var loader = "add-recipe-to-plan-modal-module--loader--e276c";
export var modal = "add-recipe-to-plan-modal-module--modal--2e459";